// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__1lXt4","text":"LimitedAccessBanner_text__2oZ6t","button":"LimitedAccessBanner_button__4JXtF"};